var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationMessages2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2712 40.89C18.3487 40.89 22.4662 36.7725 22.4662 31.695C22.4662 26.6175 18.3505 22.5 13.2712 22.5C8.1918 22.5 4.07617 26.6175 4.07617 31.695",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2806 40.8994C11.8969 40.8994 10.5863 40.5938 9.40875 40.0482L3.75 41.2501L4.93313 35.5801C4.38375 34.3988 4.07625 33.0826 4.07625 31.6951",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2944 22.5526C11.6231 21.0133 11.25 19.3351 11.25 17.5745C11.25 10.0426 17.9963 3.99951 26.25 3.99951C34.5037 3.99951 41.25 10.0426 41.25 17.5745C41.25 22.0258 38.8838 25.9445 35.2519 28.4158C35.2538 29.8333 35.25 31.7439 35.25 33.7501L29.3644 30.8514C28.3575 31.0445 27.3169 31.1495 26.25 31.1495C24.9244 31.1495 23.6381 30.992 22.4119 30.6976",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9911 31.8087C9.0277 31.8452 9.0277 31.9047 8.9911 31.9412C8.95449 31.9778 8.89512 31.9778 8.8585 31.9412C8.8219 31.9047 8.8219 31.8452 8.8585 31.8087C8.89512 31.7721 8.95449 31.7721 8.9911 31.8087Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2099 31.8087C13.2465 31.8452 13.2465 31.9047 13.2099 31.9412C13.1732 31.9778 13.1139 31.9778 13.0773 31.9412C13.0407 31.9047 13.0407 31.8452 13.0773 31.8087C13.1139 31.7721 13.1732 31.7721 13.2099 31.8087Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4286 31.8087C17.4652 31.8452 17.4652 31.9047 17.4286 31.9412C17.392 31.9778 17.3326 31.9778 17.296 31.9412C17.2594 31.9047 17.2594 31.8452 17.296 31.8087C17.3326 31.7721 17.392 31.7721 17.4286 31.8087Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.25 14.1281C26.6813 13.6556 27.4256 13.125 28.56 13.125C30.5438 13.125 31.875 14.8706 31.875 16.4963C31.875 19.8956 27.3619 22.5 26.25 22.5C25.1381 22.5 20.625 19.8956 20.625 16.4963C20.625 14.8706 21.9562 13.125 23.94 13.125C25.0744 13.125 25.8187 13.6556 26.25 14.1281Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationMessages2);
export default __webpack_public_path__ + "static/media/navigation-messages2.3da3efd0.svg";
export { ForwardRef as ReactComponent };